module.exports = __webpack_public_path__ + "img/logo_celgene.a99087cd.png";